import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-minus\"><path d=\"M.745 8.732h14.518A.746.746 0 0 0 16 8.004a.741.741 0 0 0-.737-.729H.745c-.395 0-.745.327-.745.729 0 .394.35.728.745.728Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol